import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";

import ViewSettingsDialog from "src/modal/ViewSettingsDialog";
import EditSettingsDialog from "src/modal/EditSettingsDialog";
import EditProfileCompletionOverlayDialog from "src/modal/EditProfileCompletionOverlayDialog";
import EditPassCodeSettingsDialog from "src/modal/EditPassCodeSettingsDialog";
import { get, put } from "src/utils/networkUtils";
import AppSettingsTable from "src/components/app-settings/AppSettingsTable";

export default function AppSettingsPage() {
  const [, setLoading] = useState(false);
  const [rows, setRows] = useState(null);
  const [settings, setSettings] = useState(null);
  const [isSeasonEndAlertUpdating, setIsSeasonEndAlertUpdating] =
    useState(false);
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
  const [openProfileOverlayDialog, setOpenProfileOverlayDialog] =
    useState(false);
  const [isProfileOverlayUpdating, setIsProfileOverlayUpdating] =
    useState(false);
  const [openPassCodeDialog, setOpenPassCodeDialog] = useState(false);
  const [isPassCodeUpdating, setIsPassCodeUpdating] = useState(false);
  const [updateSettings, setUpdateSettings] = useState(null);
  // const [xpLevelSettings, setXpLevelSettings] = useState(null);
  // const [openXpUpdateDialog, setOpenXpUpdateDialog] = useState(false);
  // const [updateXpSettings, setUpdateXpSettings] = useState(null);
  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [viewSettings] = useState({
    settingsType: "",
    settings: "",
  });

  useEffect(() => {
    get(`/admin/app-settings`).then(function (response) {
      setRows(response.setingsTypes);
      setSettings(response.settings);
    });

    // get(`/admin/xp-level-settings`).then(function (response) {
    //   setXpLevelSettings(response.settings);
    // });
  }, []);

  const updateSettingsHandler = () => {
    setLoading(true);
    setOpenUpdateDialog(false);
    put(`/admin/app-settings`, updateSettings).then(function () {
      window.location.reload(true);
    });
  };

  const handleToggleSeasonEndAlert = (nextValue) => {
    setIsSeasonEndAlertUpdating(true);
    const currentSettings = settings?.find((item) => item.settingsType === 9);
    let parsedCurrent = {};

    try {
      const parsed = currentSettings?.settings
        ? JSON.parse(currentSettings.settings)
        : {};
      parsedCurrent =
        parsed && typeof parsed === "object" && !Array.isArray(parsed)
          ? parsed
          : {};
    } catch {
      parsedCurrent = {};
    }

    const payload = {
      settingsType: 9,
      settings: JSON.stringify(
        {
          ...parsedCurrent,
          showAllAccessMonthlySeasonEndAlert: nextValue,
        },
        null,
        2
      ),
    };

    put(`/admin/app-settings`, payload)
      .then(() => {
        setSettings((previousSettings = []) => {
          const hasSeasonEndAlert = previousSettings.some(
            (item) => item.settingsType === 9
          );

          if (hasSeasonEndAlert) {
            return previousSettings.map((item) =>
              item.settingsType === 9
                ? { ...item, settings: payload.settings }
                : item
            );
          }

          return [...previousSettings, payload];
        });
      })
      .finally(() => {
        setIsSeasonEndAlertUpdating(false);
      });
  };

  const handleSaveProfileCompletionOverlay = (nextSettingsJson) => {
    setIsProfileOverlayUpdating(true);
    const payload = {
      settingsType: 10,
      settings: nextSettingsJson,
    };

    put(`/admin/app-settings`, payload)
      .then(() => {
        setSettings((previousSettings = []) => {
          const hasOverlaySettings = previousSettings.some(
            (item) => item.settingsType === 10
          );

          if (hasOverlaySettings) {
            return previousSettings.map((item) =>
              item.settingsType === 10
                ? { ...item, settings: payload.settings }
                : item
            );
          }

          return [...previousSettings, payload];
        });
        setOpenProfileOverlayDialog(false);
      })
      .finally(() => {
        setIsProfileOverlayUpdating(false);
      });
  };

  const handleSavePassCodeSettings = (nextSettingsJson) => {
    setIsPassCodeUpdating(true);
    const payload = {
      settingsType: 12,
      settings: nextSettingsJson,
    };

    put(`/admin/app-settings`, payload)
      .then(() => {
        setSettings((previousSettings = []) => {
          const hasPassCodeSettings = previousSettings.some(
            (item) => item.settingsType === 12
          );

          if (hasPassCodeSettings) {
            return previousSettings.map((item) =>
              item.settingsType === 12
                ? { ...item, settings: payload.settings }
                : item
            );
          }

          return [...previousSettings, payload];
        });
        setOpenPassCodeDialog(false);
      })
      .finally(() => {
        setIsPassCodeUpdating(false);
      });
  };

  const handleOpenUpdateDialog = (settingsType) => {
    const typeSettings = settings.find(
      (item) => item.settingsType === settingsType
    );

    if (settingsType === 10) {
      const defaultSettings = {
        showProfileCompletionOverlay: false,
        overlayType: "simple",
      };
      let parsedSettings = defaultSettings;

      try {
        if (typeSettings?.settings) {
          parsedSettings =
            typeof typeSettings.settings === "string"
              ? JSON.parse(typeSettings.settings)
              : typeSettings.settings;
        }
      } catch {
        parsedSettings = defaultSettings;
      }

      setUpdateSettings({
        settingsType,
        settings: JSON.stringify(parsedSettings, null, 2),
      });
      setOpenProfileOverlayDialog(true);
      return;
    }

    if (settingsType === 12) {
      const defaultSettings = {
        enabled: false,
        passcode: "",
      };
      let parsedSettings = defaultSettings;

      try {
        if (typeSettings?.settings) {
          parsedSettings =
            typeof typeSettings.settings === "string"
              ? JSON.parse(typeSettings.settings)
              : typeSettings.settings;
        }
      } catch {
        parsedSettings = defaultSettings;
      }

      setUpdateSettings({
        settingsType,
        settings: JSON.stringify(parsedSettings, null, 2),
      });
      setOpenPassCodeDialog(true);
      return;
    }

    const defaultSettings = Array.from({ length: 7 }, (_, i) => ({
      day: i + 1,
      amount: 20,
    }));

    setUpdateSettings({
      settingsType,
      settings: JSON.stringify(
        typeSettings?.settings
          ? JSON.parse(typeSettings.settings)
          : defaultSettings,
        null,
        2
      ),
    });

    setOpenUpdateDialog(true);
  };

  // const handleOpenXpUpdateDialog = (levelData) => {
  //   setUpdateXpSettings({
  //     ...levelData,
  //     settings: levelData.settings ? JSON.stringify(levelData.settings) : "{}",
  //   });
  //   setOpenXpUpdateDialog(true);
  // };

  return (
    <>
      <Helmet>
        <title> App Settings </title>
      </Helmet>

      <AppSettingsTable
        rows={rows}
        settings={settings}
        handleOpenUpdateDialog={handleOpenUpdateDialog}
        handleToggleSeasonEndAlert={handleToggleSeasonEndAlert}
        isSeasonEndAlertUpdating={isSeasonEndAlertUpdating}
      />

      {/* <XpLevelSettingsTable
        xpLevelSettings={xpLevelSettings}
        handleEdit={handleOpenXpUpdateDialog}
      /> */}

      <ViewSettingsDialog
        open={openViewDialog}
        onClose={() => setOpenViewDialog(false)}
        settingsType={viewSettings.settingsType}
        settings={viewSettings.settings}
      />

      {openUpdateDialog && (
        <EditSettingsDialog
          open={openUpdateDialog}
          onClose={() => setOpenUpdateDialog(false)}
          updateSettings={updateSettings}
          setUpdateSettings={setUpdateSettings}
          updateSettingsHandler={updateSettingsHandler}
        />
      )}

      <EditProfileCompletionOverlayDialog
        open={openProfileOverlayDialog}
        onClose={() => setOpenProfileOverlayDialog(false)}
        rawSettings={updateSettings?.settings}
        isSaving={isProfileOverlayUpdating}
        onSave={handleSaveProfileCompletionOverlay}
      />

      <EditPassCodeSettingsDialog
        open={openPassCodeDialog}
        onClose={() => setOpenPassCodeDialog(false)}
        rawSettings={updateSettings?.settings}
        isSaving={isPassCodeUpdating}
        onSave={handleSavePassCodeSettings}
      />

      {/* {openXpUpdateDialog && (
        <XpSettingsDialog
          open={openXpUpdateDialog}
          onClose={() => setOpenXpUpdateDialog(false)}
          data={updateXpSettings}
          onSave={(updatedData) => {
            setLoading(true);
            put(`/admin/xp-level-settings`, {
              ...updatedData,
              settings: updatedData.settings,
            }).then(() => {
              get(`/admin/xp-level-settings`).then((response) => {
                setXpLevelSettings(response.settings);
                setLoading(false);
              });
            });
          }}
        />
      )} */}
    </>
  );
}
